"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRenderer_1 = __importDefault(require("../ControlRenderer"));
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const TransitionRenderer_1 = __importDefault(require("../ControlRenderer/components/TransitionRenderer"));
const PageIsFocusedContext_1 = __importDefault(require("./PageIsFocusedContext"));
const useAppStateSelector_1 = __importDefault(require("../hooks/useAppStateSelector"));
const appStateSelectBOPageById_1 = __importDefault(require("../shared/appStateSelectBOPageById"));
const wrapperStyle = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
};
const transitionWrapperStyle = {
    width: '100%',
    height: '100%',
};
const PageBooter = ({ pageId, transition, isFocused, }) => {
    const page = (0, useAppStateSelector_1.default)((0, appStateSelectBOPageById_1.default)(pageId));
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    if (!page) {
        return null;
    }
    return (react_1.default.createElement(PageIsFocusedContext_1.default.Provider, { value: isFocused },
        react_1.default.createElement(Render.View, { style: wrapperStyle },
            react_1.default.createElement(TransitionRenderer_1.default, { transition: transition, style: transitionWrapperStyle },
                react_1.default.createElement(ControlRenderer_1.default, { control: page })))));
};
exports.default = PageBooter;
